import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputGroup,
} from "@chakra-ui/react";

const FromWrapper = ({
  label,
  isInvalid,
  error,
  children,
  helperText,
  wrapperProps = {},
}) => {
  return (
    <FormControl width="100%" isInvalid={isInvalid} {...wrapperProps}>
      {label && <FormLabel>{label}</FormLabel>}
      <InputGroup width="100%" alignItems="center">
        {children}
      </InputGroup>

      <FormErrorMessage pos={"absolute"} color="red" fontSize=".75rem">
        {error}
      </FormErrorMessage>
      <FormHelperText fontSize="0.75rem" color="gray.400">
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

FromWrapper.propTypes = {
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node.isRequired,
  helperText: PropTypes.string,
  wrapperProps: PropTypes.object,
};

export default FromWrapper;
